import React from 'react';
import styles from './RefundPolicy.module.css';
import Footer from '../../common/UI/Footer';
import { toast } from 'react-toastify';
import { usePageContent } from '../../hooks/usePagesSettings';
import Loading from '../../common/HousGlass Loader/Loading';
import { Helmet } from 'react-helmet';

function RefundPolicy() {
  const {
    pageContent,
    isLoading,
    error
  } = usePageContent('refund');

  if (isLoading) {
    return (
      <div className={styles.container}>
        <div className={styles.loadingContainer}>
          <div className={styles.loader}></div>
          <Loading/>
        </div>
        <Footer />
      </div>
    );
  }

  if (error) {
    toast.error('Failed to load refund policy');
    return (
      <div className={styles.container}>
        <div className={styles.errorContainer}>
          <p>Failed to load refund policy. Please try again later.</p>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <>
    <Helmet>
      <title>Refund Policy - SunoKahaniyan</title>
      <meta name="description" content="Read our Refund Policy to understand our refund terms and conditions for SunoKahaniyan services." />
    </Helmet>
    <div className={styles.container}>
      <div className={styles.pageHeader}>
        <div className={styles.headerContent}>
          <h1 className={styles.title}>Refund Policy</h1>
        </div>
      </div>
      
      <div className={styles.contentWrapper}>
        <div 
          className={styles.content}
          dangerouslySetInnerHTML={{ __html: pageContent?.content || '' }}
        />
      </div>
      <Footer />
    </div>
    </>
  );
}

export default RefundPolicy;
